import { render, staticRenderFns } from "./VipMemberLevel.vue?vue&type=template&id=4b6f46a8"
import script from "./VipMemberLevel.vue?vue&type=script&lang=js"
export * from "./VipMemberLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports